import { UNKNOWN_MERCHANT_ID } from './constants';
import { CashflowTransactionEntry } from './types';

export const filterTransactionEntries = ({
    allTransactionEntries,
    categoryIds,
    accountIds,
    tagNames,
    merchantId,
}: {
    allTransactionEntries: CashflowTransactionEntry[];
    categoryIds: string[] | null;
    accountIds: string[] | null;
    tagNames: string[] | null;
    merchantId: string | null;
}) =>
    allTransactionEntries.filter((t) => {
        let match = true;

        if (categoryIds) {
            match = match && categoryIds.includes(t.category.id);
        }

        if (accountIds) {
            match = match && accountIds.includes(t.financialEntityId);
        }

        if (tagNames) {
            match = match && t.tags.some((tag) => tagNames.includes(tag.name));
        }

        if (merchantId) {
            match =
                match && (t.merchant?.id || UNKNOWN_MERCHANT_ID) === merchantId;
        }

        return match;
    });
